import { useApi, useToaster } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { watch } from "vue";

export function useListingFaq() {
  const api = useApi();
  const toaster = useToaster();
  
  const { isLoading, error, data } = useQuery({
    queryKey: ["expert", "faqs"],
    queryFn: () => api.expert.getFaqs(),
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  watch(error, (newError) => {
    if (newError) {
      toaster.create({ 
        title: "Failed to load FAQs", 
        type: "error" 
      });
      console.error('[useListingFaq] Error:', newError);
    }
  });

  return { isLoading, error, data };
}

export default useListingFaq;
